import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useNotification } from 'hooks/useNotification';
import { teamQueryKeys } from 'TeamModule/query/teamQueryKeys';
import {
  refreshTeamIntegrationsApi,
  RefreshTeamIntegrationsPayload,
} from 'TeamModule/api/refreshTeamIntegrationsApi';

export const useRefreshTeamIntegrationsMutation = () => {
  const token = useSelector(selectAuthToken) as string | undefined;
  const { showSuccess, showError } = useNotification();
  const queryClient = useQueryClient();

  const mutation = useMutation<unknown, unknown, RefreshTeamIntegrationsPayload>({
    mutationFn: async (params) => {
      if (!token) throw new Error('Not Authenticated');
      return refreshTeamIntegrationsApi({ params, token });
    },
    onSuccess: () => {
      showSuccess('Integrations data refreshed successfully');
      queryClient.invalidateQueries({
        queryKey: teamQueryKeys.lists(),
      });
    },
    onError: () => {
      showError('Failed to refresh integrations data');
    },
  });

  return {
    refreshTeamIntegrations: mutation.mutate,
    isRefreshingTeamIntegrations: mutation.isPending,
  };
};

export default useRefreshTeamIntegrationsMutation;
